"use client";

import { useEffect } from "react";
import { setReferralCookie } from "utils/referral-cookie";

interface ReferralCaptureProps {
  code: string;
  citySlug?: string;
}

export function ReferralCapture({ code, citySlug }: ReferralCaptureProps) {
  useEffect(() => {
    setReferralCookie(code, citySlug);
  }, [code, citySlug]);

  return null;
}
